"use strict";
// has ArcGIS API been loaded on the page yet?
function isLoaded() {
    // would like to just use window.require, but fucking typescript
    return typeof window['require'] !== 'undefined';
}
exports.isLoaded = isLoaded;
// load the ArcGIS API on the page
function bootstrap(callback, options) {
    if (options === void 0) { options = {}; }
    // default options
    if (!options.url) {
        options.url = 'https://js.arcgis.com/4.2/';
    }
    // don't reload API if it is already loaded
    if (isLoaded()) {
        callback(new Error('The ArcGIS API for JavaScript is already loaded.'));
        return;
    }
    // create a script object whose source points to the API
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = options.url;
    // once the script is loaded...
    script.onload = function () {
        // we can now use Dojo's require() to load esri and dojo AMD modules
        var dojoRequire = window['require'];
        // let the caller know that the API has been successfully loaded
        // and as a convenience, return the require function 
        // in case they want to use it directly
        callback(null, dojoRequire);
    };
    // load the script
    document.body.appendChild(script);
}
exports.bootstrap = bootstrap;
// prevent people from getting require undefined error
function dojoRequire(modules, callback) {
    if (!isLoaded()) {
        throw new Error('The ArcGIS API for JavaScript has not been loaded. You must first call esriLoader.bootstrap()');
    }
    else {
        window['require'](modules, callback);
    }
}
exports.dojoRequire = dojoRequire;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/esri-loader/index.js
// module id = 10
// module chunks = 0